import Glide from '@glidejs/glide'

const activeBullet = "glide__bullet--active";

const changeActiveBullet = (newIndex, containerElement) => {
    if (!containerElement) return;

    const glideDir = containerElement.querySelector(
        `[data-glide-dir="=${newIndex}"]`
    );

    const currentActive = containerElement.querySelector(`.${activeBullet}`);
    if (currentActive) {
        currentActive.classList.remove(activeBullet);
    }

    if (glideDir) glideDir.classList.add(activeBullet);
};

const newsEl = document.querySelector('#NewsGlide');
if (newsEl) {
    const newsBulletsContainer = newsEl.querySelector(".glide__bullets");
    const newsSlider = new Glide(newsEl, {
        type: 'carousel',
        perView: 3,
        peek: 200,
        gap: 30,
        breakpoints: {
            1400: {
                perView: 3,
                peek: 100,
                gap: 20,
            },
            1200: {
                perView: 2,
                peek: 100,
                gap: 20,
            },
            992: {
                perView: 2,
                peek: 50,
                gap: 10,
            },
            768: {
                perView: 1,
                peek: 10,
                gap: 10,
            },
        }
    });
    newsSlider.mount();
    newsSlider.on("run", () => {
        requestAnimationFrame(() => {
          changeActiveBullet(newsSlider.index, newsBulletsContainer);
        });
    });
}

// Carousel so the first slide can peek the last video on the left.
const whyEl = document.querySelector('#WhyGlide');
if (whyEl) {
    const whyBulletsContainer = whyEl.querySelector(".glide__bullets");
    const whySlider = new Glide(whyEl, {
        type: 'carousel',
        perView: 1,
        peek: 200,
        gap: 30,
        breakpoints: {
            1400: {
                peek: 100,
                gap: 24,
            },
            1200: {
                peek: 100,
                gap: 20,
            },
            992: {
                peek: 0,
                gap: 16,
            },
            768: {
                peek: 0,
                gap: 12,
            },
        },
    });

    const pauseWhyVideos = () => {
        whyEl.querySelectorAll('iframe').forEach((iframe) => {
            if (!iframe.contentWindow) return;
            iframe.contentWindow.postMessage(JSON.stringify({
                event: 'command',
                func: 'pauseVideo',
                args: '',
            }), '*');
        });
    };

    whySlider.on("run.before", pauseWhyVideos);
    whySlider.mount();
    whySlider.on("run", () => {
        requestAnimationFrame(() => {
            changeActiveBullet(whySlider.index, whyBulletsContainer);
        });
    });
}

const quotesEl = document.querySelector('#QuotesGlide');
if (quotesEl) {
    const quotesBulletsContainer = quotesEl.querySelector('.glide__bullets');
    const quotesSlider = new Glide(quotesEl, {
        type: 'carousel',
        perView: 3,
        gap: 24,
        peek: 0,
        breakpoints: {
            1200: {
                perView: 2,
                gap: 20,
            },
            768: {
                perView: 1,
                gap: 16,
            },
        },
    });
    quotesSlider.mount();
    quotesSlider.on('run', () => {
        requestAnimationFrame(() => {
            changeActiveBullet(quotesSlider.index, quotesBulletsContainer);
        });
    });

    quotesEl.addEventListener('click', async (event) => {
        const button = event.target.closest('[data-copy-link]');
        if (!button) return;

        const url = button.getAttribute('data-copy-link');
        const label = button.querySelector('span');
        const copiedLabel = button.getAttribute('data-copied-label') || 'Link copied';
        if (!url || !label || !navigator.clipboard) return;

        const original = label.textContent;
        try {
            await navigator.clipboard.writeText(url);
            label.textContent = copiedLabel;
            window.setTimeout(() => {
                label.textContent = original;
            }, 2000);
        } catch (error) {
            label.textContent = original;
        }
    });
}

// Action Center only — separate from homepage #NewsGlide
// Desktop: static 3-up grid (CSS). Tablet/mobile: Glide slider.
const actionNewsEl = document.querySelector('#ActionNewsGlide');
if (actionNewsEl) {
    const activeBulletClass = "glide__bullet--active";
    const actionBulletsContainer = actionNewsEl.querySelector(".glide__bullets");
    const actionNewsMq = window.matchMedia('(max-width: 991.98px)');
    let actionNewsSlider = null;

    const updateActionBullets = () => {
        if (!actionNewsSlider || !actionBulletsContainer) return;
        const glideDir = actionBulletsContainer.querySelector(
            `[data-glide-dir="=${actionNewsSlider.index}"]`
        );
        const currentActive = actionBulletsContainer.querySelector(`.${activeBulletClass}`);
        if (currentActive) {
            currentActive.classList.remove(activeBulletClass);
        }
        if (glideDir) glideDir.classList.add(activeBulletClass);
    };

    const mountActionNews = () => {
        if (actionNewsSlider) return;
        actionNewsSlider = new Glide(actionNewsEl, {
            type: 'slider',
            perView: 2,
            peek: 0,
            gap: 20,
            bound: true,
            breakpoints: {
                768: {
                    perView: 1,
                    gap: 16,
                },
            },
        });
        actionNewsSlider.on("run", () => {
            requestAnimationFrame(updateActionBullets);
        });
        actionNewsSlider.mount();
        updateActionBullets();
    };

    const destroyActionNews = () => {
        if (!actionNewsSlider) return;
        actionNewsSlider.destroy();
        actionNewsSlider = null;
    };

    const syncActionNews = () => {
        if (actionNewsMq.matches) {
            mountActionNews();
        } else {
            destroyActionNews();
        }
    };

    syncActionNews();
    if (typeof actionNewsMq.addEventListener === 'function') {
        actionNewsMq.addEventListener('change', syncActionNews);
    } else if (typeof actionNewsMq.addListener === 'function') {
        actionNewsMq.addListener(syncActionNews);
    }
}
